import { CURRENCY_POINTS, INCENTIVE_PAYMENT_METHOD, STUDY_PERSON_INCENTIVE_STATUS } from 'utils/constants';

/**
 * Determines if a payment is editable based on the given study person object.
 *
 * The function evaluates a series of conditions to check if the payment is editable:
 * 1. The `incentive_status` of the study person must be 'paid'.
 * 2. The `incentive_currency` must not be equal to `CURRENCY_POINTS`, indicating the payment is not in points.
 * 3. The `incentive_receipt` should match the `INCENTIVE_PAYMENT_METHOD.MARK_AS_PAID` method.
 *
 * @param {{
 *     incentive_status?: string,
 *     incentive_currency?: string
 *     incentive_receipt?: INCENTIVE_PAYMENT_METHOD
 * }} studyPerson - The object representing an individual related to the study, containing details about incentive payments.
 * @returns {boolean} - Returns true if the payment is editable based on the specified conditions; otherwise, false.
 */
export const checkIfPaymentEditable = studyPerson =>
    studyPerson.incentive_status === STUDY_PERSON_INCENTIVE_STATUS.PAID && // the status of the payment is paid
    studyPerson.incentive_currency !== CURRENCY_POINTS && // the payment is not in points
    studyPerson.incentive_receipt === INCENTIVE_PAYMENT_METHOD.MARK_AS_PAID; // the payment is marked as paid (manual)
